import { act, useMemo, useState } from 'react';

import { ActionItem, Process } from '@urbanmix-tech/shared-js';

import { ActionGroup } from './TrackerActionGroup';
import {
  getProcess,
  getProcesses,
  saveActionItem,
  saveProcess,
} from '@/data';
import { convertPseudoDateToRealDate } from '@/helpers/common';
import { useSelector } from 'react-redux';
import { Button, Alert, Stack, Box, CircularProgress, Typography } from '@mui/material';
import { useAlert } from '@/contexts/Alert/AlertContext';
import { useAuth } from '@/shared/context/AuthProvider';

function makeNewProcess(processId: string | null, actionItem: ActionItem) {
  console.log('makeNewProcess', processId, actionItem);
  let newProcessId : string | null = null;
  if (!processId) {
    newProcessId = actionItem.response?.additionalInfo?.applicationId;
    if (actionItem.response?.envelopeId) {
      newProcessId = actionItem.response?.envelopeId;
    }
    if (actionItem.response?.evenlopeId) {
      newProcessId = actionItem.response?.evenlopeId;
    }
    if (actionItem.response?.year1Increase) {
      newProcessId = actionItem.unitId + "_slr_" + actionItem.response?.year1Incrase;
    }
  } else {
    newProcessId = processId;
  }
  console.log('makeNewProcess', newProcessId, actionItem);
  if (newProcessId) {
    console.log('saving new process', newProcessId);
    getProcess(newProcessId)
      .catch(() => {
        console.log('catch saving new process', processId);
        saveProcess({
          name: 'New Lease',
          description: 'New Lease for application ' + processId,
          id: processId!,
          type: 'new_lease',
          unitId: actionItem.unitId,
          projectId: actionItem.projectId,
          buildingId: actionItem.buildingId,
          status: 'open',
          webhook_url: undefined,
          webhook_secret: undefined,
          startedAt: convertPseudoDateToRealDate(actionItem.createDate) || undefined,
          updatedAt: new Date(),
          completedAt: undefined,
          parameters: [],
          workflows: [],
        });
      })
      .then((process) => {
        console.log('then new process', process);
        if (!process) {
          console.log('saving new process', newProcessId,actionItem.unitId,actionItem.projectId);
          const createDate = convertPseudoDateToRealDate(actionItem.createDate) ?? new Date();
          saveProcess({
            name: 'New Lease',
            description: 'New Lease for application ' + processId,
            id: processId!,
            type: 'new_lease',
            unitId: actionItem.unitId,
            projectId: actionItem.projectId,
            buildingId: actionItem.buildingId,
            status: 'open',
            webhook_url: undefined,
            webhook_secret: undefined,
            startedAt: convertPseudoDateToRealDate(actionItem.createDate) || undefined,
            updatedAt: new Date(),
            completedAt: undefined,
            parameters: [],
            workflows: [],
          }).catch((e) => {
            console.log('error saving new process', e);
            return newProcessId;;
          }).then((p) => {
            console.log('saved new process', p);
            let updateActionItem = { ...actionItem };
            updateActionItem.processId = newProcessId!;
            saveActionItem(updateActionItem).catch((e) => {
              console.log('error saving action item', e);
              return newProcessId;;
            }
            ).then((ai) => {
              console.log('saved action item', ai);
              return newProcessId;
            });

            return newProcessId;;
          });           
        }
      });
    
  }
  return newProcessId;;
}


export type ActionGroupListProps = {
  actionItems: ActionItem[];
  onClickActionItem(actionItem: ActionItem): void;
  onHoverItem?: (actionItem: ActionItem ) => void;
  onBuildingDataChange?: (data: Record<string, any>) => void;
  sortOrder?: string;
  showFutureTasks?: boolean;
  showIgnoredTasks?: boolean;
  isLoading?: boolean;
};

export function ActionGroupList({
  actionItems,
  onClickActionItem,
  onHoverItem,
  sortOrder,
  showFutureTasks = true,
  showIgnoredTasks = false,
  isLoading = false,
}: ActionGroupListProps) {
  const processes = useSelector((state: any) => state.project.processes);
  console.log('got processes at group list', processes);
  console.log('actionItems', actionItems);

  const { userData, isEditMode } = useAuth();
  const [selectedProcess, setSelectedProcess] = useState<Process | null>(null);
  const [processEditMode, setProcessEditMode] = useState(false);

  // Migration state
  const [isMigrating, setIsMigrating] = useState(false);
  const [migrationMessage, setMigrationMessage] = useState('');
  const [showMigrationAlert, setShowMigrationAlert] = useState(false);
  const { showAlert } = useAlert();

  const filteredProcesses = useMemo(() => {
    console.log('filtering processes', processes);
    return processes?.filter((p: Process) => p.status !== '1cancelled');
  }, [processes]);

  const groups = useMemo(() => {
    const unitMap: Record<string, any> = {};
    actionItems
    .filter((a) => (a.status === 'ignored' && showIgnoredTasks) || a.status !== 'ignored')
    .filter((a) => (a.status === 'future' && showFutureTasks) || a.status !== 'future')
    .forEach((actionItem) => {
      

      let processId = actionItem.processId ?? null;
      // console.log('scannign processes . actionItem', actionItem.processId,processId,actionItem.title,actionItem.status)
      if (!processId) {
        // processId = makeNewProcess(processId, actionItem);
      } else {
        // console.log('found process',processId,actionItem.unitId,actionItem.title,actionItem.status);
      }
      
      let key = processId ?? actionItem.unitId;
      // console.log('%%actionItem', actionItem.unitId, actionItem);      
      if (unitMap[key] === undefined) {
        unitMap[key] = {
          unitId: actionItem.unitId,
          actionItems: [],
          minDueDate: Infinity,
          maxCreatedAt: -Infinity,
        };
      }
      unitMap[key].actionItems.push(actionItem);
      if (actionItem.createDate) {
        const d = convertPseudoDateToRealDate(actionItem.createDate);
        if (d)
          unitMap[key].maxCreatedAt = Math.max(
            unitMap[key].maxCreatedAt,
            d.getTime()
          );
      }
      if (actionItem.dueDate) {
        const d = convertPseudoDateToRealDate(actionItem.dueDate);
        if (d)
          unitMap[key].minDueDate = Math.min(
            unitMap[key].minDueDate,
            d.getTime()
          );
      }
    });

    return Object.keys(unitMap)
      .sort((a, b) => {
        if (sortOrder === 'dueDate') {
          return unitMap[a].minDueDate - unitMap[b].minDueDate;
        } else if (sortOrder === 'createdAt') {
          return unitMap[b].maxCreatedAt - unitMap[a].maxCreatedAt;
        }
        return 0;
      })
      .map((key) => {
        const group = unitMap[key];
        // console.log('group', key, group);
        return {
          id: key,
          unitId: group.unitId,
          actionItems: group.actionItems,
          process: filteredProcesses
            ? filteredProcesses.find((p: Process) => p.id === key)
            : null,
        };
      })
      .filter((item) => item.actionItems.length > 0);
  }, [actionItems, filteredProcesses, sortOrder]);

  // Find processes with status "open" from the groups
  const openProcesses = useMemo(() => {
    return groups
      .filter((group) => group.process && group.process.status === 'open')
      .map((group) => group.process)
      .filter((p): p is Process => p !== null);
  }, [groups]);

  const handleMigrateProcesses = async () => {
    if (openProcesses.length === 0) {
      setMigrationMessage('No processes with status "open" found');
      setShowMigrationAlert(true);
      return;
    }

    // Confirm with user before migration
    const confirmed = window.confirm(
      `This will update ${openProcesses.length} process(es) from "open" to "start". ` +
      `The page will update automatically as the changes are saved. Continue?`
    );

    if (!confirmed) return;

    try {
      setIsMigrating(true);
      setMigrationMessage(`Updating ${openProcesses.length} process(es)... Please wait, the list will refresh automatically.`);
      setShowMigrationAlert(true);

      // Update each process using saveProcess in parallel
      // The Firestore subscription will automatically update Redux as changes occur
      await Promise.all(
        openProcesses.map((process) =>
          saveProcess({ ...process, status: 'start' })
        )
      );

      setMigrationMessage(`Successfully updated ${openProcesses.length} process(es) from "open" to "start"`);
      showAlert(`Updated ${openProcesses.length} process(es)`, 'success');

      // Hide alert after 5 seconds
      setTimeout(() => {
        setShowMigrationAlert(false);
      }, 5000);
    } catch (error) {
      console.error('Migration error:', error);
      setMigrationMessage(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
      showAlert('Failed to update processes', 'error');
    } finally {
      setIsMigrating(false);
    }
  };

  return (
    <div className="flex w-full flex-col gap-16 overflow-auto">
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>

        {openProcesses.length > 0 && (
          <Button
            type="button"
            variant="contained"
            color="warning"
            onClick={handleMigrateProcesses}
            disabled={isMigrating}
            size="small"
          >
            {isMigrating ? 'Migrating...' : `Migrate ${openProcesses.length} Process(es) from "open" to "start"`}
          </Button>
        )}
      </Stack>

      {showMigrationAlert && (
        <Box sx={{ mb: 2 }}>
          <Alert severity={isMigrating ? 'info' : 'success'}>
            {migrationMessage}
          </Alert>
        </Box>
      )} 
      {selectedProcess && (
        <div>
          <div>{selectedProcess.id}</div>
          <div>{selectedProcess.type}</div>
        </div>)}
      {isLoading ? (
        <Stack alignItems="center" justifyContent="center" sx={{ py: 8, gap: 1.5 }}>
          <CircularProgress size={28} />
          <Typography sx={{ color: '#a8a29e', fontSize: '0.875rem' }}>
            Loading tasks…
          </Typography>
        </Stack>
      ) : groups.length === 0 ? (
        <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
          <Typography sx={{ color: '#a8a29e', fontSize: '0.875rem' }}>
            No tasks
          </Typography>
        </Stack>
      ) : (
        groups.map((group) => (
          <ActionGroup
            process={group.process}
            key={group.id}
            actionItems={group.actionItems}
            category="Recent"
            unitId={group.unitId}
            onClickActionItem={(i) => {
              console.log(i);
              if (processEditMode && selectedProcess) {
                let updatedActionItem = { ...i };
                updatedActionItem.processId = selectedProcess.id;
                saveActionItem(updatedActionItem).then(() => {
                })
              } else if (processEditMode) {
                makeNewProcess(i.processId ?? (i.unitId + "_" + i.id),i)
              } else {
                onClickActionItem(i);
              }

            }}
            onHoverItem={onHoverItem}
            onProcessClick={(p) => {if (p !== selectedProcess) {
              setSelectedProcess(p)
             } else {
              setSelectedProcess(null)
             }
            }}
            editMode={userData?.isDev && isEditMode}
            selected={selectedProcess?.id === group.id}
          />
        ))
      )}
    </div>
  );
}

